/* eslint-disable import/no-relative-packages */
import React, {
  createContext, useContext, useEffect, useMemo,
} from 'react';
import moment from 'moment';

import en from '../../resources/l10n/en.json';

// One language, deliberately. The tracking application this was forked from shipped fifty-five
// locales, but only its own screens ever called t(): every screen this product added — the Command
// Center, the gate and parking desks, tracking, configuration and reports — is written in English
// in the source. A language picker therefore translated the sign-in page and nothing behind it, and
// somebody who chose a script they could not read had no way back to English. Translating the
// product is real work with its own review; until that is done the application says one language
// and means it. Adding a locale back means adding its file here and translating the product's own
// strings, not only this map.
const languages = {
  en: { data: en, name: 'English' },
};

const LocalizationContext = createContext({
  languages,
  language: 'en',
  setLanguage: () => {},
});

export const LocalizationProvider = ({ children }) => {
  const value = useMemo(() => ({ languages, language: 'en', setLanguage: () => {} }), []);

  useEffect(() => { moment.locale('en'); }, []);

  return (
    <LocalizationContext.Provider value={value}>
      {children}
    </LocalizationContext.Provider>
  );
};

export const useLocalization = () => useContext(LocalizationContext);

export const useTranslation = () => {
  const context = useContext(LocalizationContext);
  const { data } = context.languages[context.language];
  return useMemo(() => (key) => data[key], [data]);
};
